import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {GoogleMap,MapCircle,MapAdvancedMarker} from '@angular/google-maps';
import { MapMarkerService } from '../../../services/map-marker.service';
import { environment } from '../../../environments/environment';


//定義資料型態
interface MapMarker {
  position:  google.maps.LatLngLiteral;
  name:      string;
  stationId: string;
}



@Component({
  selector: 'traffic-google-map',
  standalone: true,
  //引用的功能
  imports: [GoogleMap,MapCircle,MapAdvancedMarker],
  templateUrl: './google-map.component.html',
})


export class GoogleMapComponent {

  /*--------------------組件與服務初始化-------------------*/


  // [ClienteService] 定義服務
  constructor(private markerService: MapMarkerService) {
  }
  // [GoogleMap] 子組件
  @ViewChild(GoogleMap) readonly map!: GoogleMap;

  // [callBack] 回傳父組件事件
  @Output() callBack =  new EventEmitter<{ type: string, name: string, stationId:string }>();




  /*--------------------地圖基礎設定---------------------*/

  // 地圖中心座標
  center: google.maps.LatLngLiteral = {lat: 24.18780271497496 , lng: 120.6642562077388};

  mapCenter: google.maps.LatLngLiteral = {lat: 24.18780271497496 , lng: 120.6642562077388};
  // 預設地圖大小
  zoom = 17;

  // 其他不會變動的設定值
  options: google.maps.MapOptions = {

    //地圖大小區間
    maxZoom: 20,
    minZoom: 12,

    //(必填)地圖標記功能使用
    mapId: "MAAS_MAP_TRAFFIC",

    // 除了地圖大小控制項，其他UI介面不顯示
    streetViewControl: false,
    fullscreenControl:false,
    mapTypeControl:false,

    // 地圖大小控制項預設位置: 4.0(左側中間)
    zoomControlOptions: {
      position: 4.0
    }
  };


  /*--------------------中心圓圈半徑顯示---------------------*/



  //半徑(公尺)
  radius = environment.trafficSize;


  circleOptions :google.maps.CircleOptions  ={
    //填滿
    fillOpacity:0.05,

    //邊框
    strokeOpacity:0.2,
    strokeWeight:1,
  }


  /*--------------------交通方式地圖標記--------------------*/
  //顯示類別
  type ="ALL";

  //地圖標記
  mrtMarkers: MapMarker[] = [];
  thsrcMarkers: MapMarker[] = [];
  traMarkers: MapMarker[] = [];
  busMarkers: MapMarker[] = [];
  nhptMarkers: MapMarker[] = [];
  bikeMarkers: MapMarker[] = [];





 /*--------------------angular 預設 funtion()---------------------*/

  /**
  * ngOnInit(初始化後呼叫)
  */
  ngOnInit(){

    //捷運
    this.markerService.getMrt().subscribe((mrtObject:any) => {
      this.mrtMarkers = [];
      for(let mrt of mrtObject){
        this.mrtMarkers.push({
          position: { lat: mrt.lat, lng: mrt.lng },
          name: mrt.name,
          stationId:''
        })
      }
    });

    //高鐵
    const ThsrcObject = this.markerService.getThsrc();
    for(let thsr of ThsrcObject){
      this.thsrcMarkers.push({
        position: { lat: thsr.position.lat, lng: thsr.position.lng },
        name: thsr.name,
        stationId:''
      })
    }

    //臺鐵
    this.markerService.getTra().subscribe((traObject:any) => {
      this.traMarkers = [];
      for(let tra of traObject){
        this.traMarkers.push({
          position: { lat: tra.lat, lng: tra.lng },
          name: tra.name,
          stationId: tra.stationId
        })
      }
    });


    //市區公車
    this.markerService.getBus().subscribe((busObject:any) => {
      this.busMarkers = [];
      for(let bus of busObject){
        this.busMarkers.push({
          position: { lat: bus.lat, lng: bus.lng },
          name: bus.name,
          stationId: bus.stationId
        })
      }
    });

    //國道客運
     this.markerService.getNhpt().subscribe((nhptObject:any) => {
      this.nhptMarkers = [];
      for(let nhpt of nhptObject){
        this.nhptMarkers.push({
          position: { lat: nhpt.lat, lng: nhpt.lng },
          name: nhpt.name,
          stationId: nhpt.stationId
        })
      }
    });

    //i-bike
    this.markerService.getBike().subscribe((bikeObject:any) => {
      this.bikeMarkers = [];
      for(let bike of bikeObject){
        this.bikeMarkers.push({
          position: { lat: bike.lat, lng: bike.lng },
          name: bike.name,
          stationId: bike.stationId
        })
      }
    });

  }



  createMarkerOptions(type: string): google.maps.marker.AdvancedMarkerElementOptions {
    let divElement = document.createElement('div');
    let imgElement = document.createElement('img');
    imgElement.src = "/static/images/svg/mapic_" + type + ".svg";
    imgElement.width = 30;
    divElement.appendChild(imgElement);

    return {
      content: divElement,
      gmpClickable: true,
    };


  }
  showMapMarker(type:string){
    this.type = type
  }

  showDetail(typeParam:string,nameParam:string,stationIdParam:string){
    this.callBack.emit(
      {
        type:typeParam,
        name:nameParam,
        stationId:stationIdParam
      }
    );
  }

  getLocal() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.mapCenter =  {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        },
        (error) => {
          console.log('Geolocation error:', error);
        }
      );
    }

  }

  dragAction(){
    this.mapCenter =  {
      lat: this.map.getCenter().lat(),
      lng: this.map.getCenter().lng()
    };
  }

  getDistanceFromLatLonInKm( lat:number, lng:number) {
    const R = 6371;
    const centerLat = this.mapCenter.lat;
    const centerLng = this.mapCenter.lng;
    const dLat = (centerLat - lat) * (Math.PI / 180);
    const dLon = (centerLng - lng) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((centerLat) * (Math.PI / 180)) * Math.cos((lat) * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;

    return d <= (environment.trafficSize/1000);
  }

}
